import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [active, setActive] = useState(localStorage.getItem("vtz_company") || "");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user) return;
    api
      .get("/companies")
      .then((r) => {
        const list = r.data.companies || [];
        setCompanies(list);
        const stored = localStorage.getItem("vtz_company");
        let cid = list.find((c) => c.id === stored)?.id;
        if (!cid) cid = list.find((c) => c.id === r.data.last)?.id || list[0]?.id || "vtz";
        if (cid !== stored) localStorage.setItem("vtz_company", cid);
        setActive(cid);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, [user]);

  const switchCompany = async (cid) => {
    if (cid === active) return;
    try {
      await api.put("/me/company", { company_id: cid });
    } catch {
      /* preference save is best-effort */
    }
    localStorage.setItem("vtz_company", cid);
    window.location.reload();
  };

  const company = companies.find((c) => c.id === active) || null;

  return (
    <CompanyContext.Provider value={{ companies, active, company, switchCompany, loaded }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () =>
  useContext(CompanyContext) || { companies: [], active: "vtz", company: null, switchCompany: () => {}, loaded: true };
